import { render, staticRenderFns } from "./ApiSubjectCardList.vue?vue&type=template&id=58a97cdc&"
import script from "./ApiSubjectCardList.vue?vue&type=script&lang=js&"
export * from "./ApiSubjectCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports